import {
  all,
  call,
  put,
  takeLatest,
  takeEvery,
  select,
} from 'redux-saga/effects';
import { stopSubmit } from 'redux-form';
import Cookies from 'js-cookie';
import axios from 'axios';
import qs from 'qs';

import { backendUrl } from '@config';

import {
  authLoginRequest,
  authLoginSuccess,
  authLoginFailure,
  authLogoutRequest,
  authLogoutSuccess,
  authUnauthorized,
  authGotoNext,
  authGotoOn,
  authLoginChoice,
  authLoginNewPasswordSuccess,
  authLoginNewPasswordFailure,
  authVerifyUser,
  authVerifyUserRequest,
  authVerifyUserSuccess,
  authVerifyUserFailure,
} from '@actions/auth.actions';

import { configGetConfig } from '@actions/config.actions';

import { getSecondData } from '../selectors/auth.selectors';

import { authLoginNewPasswordRequest } from '../actions/auth.actions';

function* gotoNext(action) {
  if (action.payload === 'grape') {
    const secondData = yield select(getSecondData);
    const { username, password } = secondData;
    yield call(
      () =>
        axios
          .request({
            method: 'POST',
            url: 'https://coop.snappergrape.no/api/login',
            data: qs.stringify({
              password,
              user_name: username,
              login: 1,
            }),
            withCredentials: true,
          })
          .then(({ data }) => data),
      { username, password }
    );
    yield put(authGotoOn());
    window.location = 'https://coop.snappergrape.no';
  } else {
    yield put(authGotoOn());
    window.location.reload();
  }
}

function* login(action) {
  const { username, password } = action.payload;
  try {
    const { login, valid } = yield call(
      ({ username: user_name, password }) =>
        axios
          .request({
            method: 'POST',
            url: `${backendUrl}/api/login`,
            data: qs.stringify({
              password,
              user_name,
              login: 1,
            }),
            withCredentials: true,
          })
          .then(({ data }) => data),
      { username, password }
    );

    if (!valid) {
      throw new Error('Invalid user');
    }

    const { session_id } = login;
    Cookies.set('identity_login_attempted', 0);
    Cookies.set('tg-visit', session_id);
    localStorage.removeItem('orgId');
    yield put({ type: 'RESET_STORE' });

    const [positions, roles] = yield all([
      call(() =>
        axios
          .request({
            method: 'GET',
            url: `${backendUrl}/api/positions`,
            params: {
              fields: 'id,title',
              user_name: username,
            },
            withCredentials: true,
          })
          .then(({ data: { positions } }) => positions)
      ),
      call(() =>
        axios
          .request({
            method: 'GET',
            url: `${backendUrl}/api/roles`,
            params: {
              fields: 'title',
              user_name: username,
            },
            withCredentials: true,
          })
          .then(({ data: { roles } }) => roles)
      ),
    ]);

    yield put(configGetConfig());
    /*
     * CHECK IF USE SHOULD BE HERE OR IN GRAPE.
     * */
    const grape_names = [
      'Administrasjon',
      'Administrerende direktør',
      'Daglig leder',
      'Direktør',
      'Disponent',
      'Varehussjef',
      'Distriktssjef',
      'Salgsleder',
      'Driftsleder',
      'Driftssjef',
      'Hovedkontor - leder',
      'Hovedkontor - medarbeider',
      'Leder',
      'Regionssjef',
    ];

    let hasChoice = false;
    if (Array.isArray(positions)) {
      const pos = positions.some(p => grape_names.includes(p.title));
      hasChoice = pos;
    }

    if (!hasChoice) {
      if (Array.isArray(roles)) {
        const pos = roles.some(p => grape_names.includes(p.title));
        hasChoice = pos;
      }
    }

    yield put(authLoginSuccess({ authProfile: login }));
  } catch (error) {
    console.log(error);
    yield put(
      stopSubmit('login', {
        errorMsg: 'Kunne ikke logge inn',
      })
    );
    yield put(authLoginFailure({ error }));
  }
}

function* checkLogin(action) {
  try {
    const { username } = action.payload;
    const { data } = yield call(() =>
      axios.request({
        method: 'POST',
        params: {
          json: 1,
          ajax: 1,
          user_name: username,
        },
        url: `${backendUrl}/api/verify_user`,
        withCredentials: true,
      })
    );
    console.log(data);
    if (data.valid) {
      if (data.auth_url) {
        window.location = data.auth_url;
      }
      yield put(authVerifyUserSuccess({ message: 'valid' }));
    } else {
      yield put(authVerifyUserSuccess({ message: 'no-user' }));
    }
  } catch (error) {
    yield put(authVerifyUserFailure({}));
  }
}

function* newPassword(action) {
  try {
    const { username } = action.payload;
    const { data } = yield call(() =>
      axios.request({
        method: 'POST',
        params: {
          json: 1,
          ajax: 1,
          email_or_user_name: username,
        },
        url: `${backendUrl}/sendreminder`,
        withCredentials: true,
      })
    );

    if (data.statuscode === 0) {
      yield put(authLoginNewPasswordSuccess({ message: data.status }));
    } else {
      yield put(authLoginNewPasswordFailure({ message: data.status }));
    }
  } catch (error) {
    yield put(authLoginNewPasswordFailure({}));
  }
}

function* logout() {
  try {
    yield call(() =>
      axios.request({
        method: 'POST',
        url: `${backendUrl}/api/logout`,
        withCredentials: true,
      })
    );
    Cookies.remove('identity_login_attempted');
    Cookies.remove('tg-visit');
    yield put(authLogoutSuccess());
  } catch (error) {
    Cookies.remove('identity_login_attempted');
    Cookies.remove('tg-visit');
    yield put(authLogoutSuccess());
  }
}

export default [
  takeLatest(authLoginRequest().type, login),
  takeLatest(authLogoutRequest().type, logout),
  takeLatest(authVerifyUser().type, checkLogin),
  takeLatest(authLoginNewPasswordRequest().type, newPassword),
  takeLatest(authGotoNext().type, gotoNext),
  takeEvery(authUnauthorized().type, logout),
];
